// extracted by mini-css-extract-plugin
export default {"container":"uztt5B0YONjz4XQDRAqE","consentText":"rObdJtwm8jLmgBijuVwg"};